import React from 'react';
import { VideoItem } from '../constants/videos';

export interface SelectedVideosState {
  selectedVideos: VideoItem[];
  toggleVideo: (video: VideoItem) => void;
  clearSelection: () => void;
  isSelected: (videoId: string) => boolean;
}

const SelectedVideosContext = React.createContext<SelectedVideosState>({
  selectedVideos: [],
  toggleVideo: () => {},
  clearSelection: () => {},
  isSelected: () => false
});

export const SelectedVideosProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [selectedVideos, setSelectedVideos] = React.useState<VideoItem[]>([]);

  // Single-video selection: toggling replaces the current selection (or clears
  // it if the same video is clicked again). Siempre hay 0 o 1 videos seleccionados.
  const toggleVideo = (video: VideoItem) => {
    setSelectedVideos(prev => {
      const exists = prev.find(v => v.id === video.id);
      if (exists) return [];
      return [video];
    });
  };

  const clearSelection = () => setSelectedVideos([]);

  const isSelected = (videoId: string) => selectedVideos.some(v => v.id === videoId);

  return (
    <SelectedVideosContext.Provider value={{ selectedVideos, toggleVideo, clearSelection, isSelected }}>
      {children}
    </SelectedVideosContext.Provider>
  );
};

export const useSelectedVideos = () => React.useContext(SelectedVideosContext);
